module.exports = __webpack_public_path__ + "static/ring_of_djinni_summoning-7c233970076ff79e48a4024ee3bb9732.jpeg";